var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 5.8332L13.8249 4.6582L8.54155 9.94154L9.71655 11.1165L14.9999 5.8332ZM18.5332 4.6582L9.71655 13.4749L6.23322 9.99987L5.05822 11.1749L9.71655 15.8332L19.7166 5.8332L18.5332 4.6582ZM0.341553 11.1749L4.99989 15.8332L6.17489 14.6582L1.52489 9.99987L0.341553 11.1749Z",
    fill: "#68A395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAll);
export default __webpack_public_path__ + "static/media/done-all.274d277327f27626e1320937dd4f8978.svg";
export { ForwardRef as ReactComponent };